// Library
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
export const userSlice = createSlice({
  name: "user",
  initialState: {
    session: null,
    userInfo: null,
    userRole: -1,
    userProfile: {
      state: null,
      district: null,
      block: null,
      school: null,
    },
  },
  reducers: {
    setUserInfo: (state, action) => {
      // console.log(action.payload);
      state.userInfo = action.payload;
    },
    setUserRole: (state, action) => {
      state.userRole = action.payload;
      // console.log(state.userRole);
    },
    setSession: (state, action) => {
      state.session = action.payload;
    },
    setUserProfile: (state, { payload }) => {
      state.userProfile.state = payload.state || null;
      state.userProfile.district = payload.district || null;
      state.userProfile.block = payload.block || null;
      state.userProfile.school = payload.school || null;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUserInfo, setUserRole, setSession, setUserProfile } =
  userSlice.actions;
export default userSlice.reducer;
